import React from "react"

const TUploadImage = ({ uri }) => {
  return (
    <th>
      <a target="_blank" href={"/admin/frame-images/" + uri}>
        Upload Images
      </a>
    </th>
  )
}

export default TUploadImage;



// WEBPACK FOOTER //
// ./src/new-components/admin/table/TUploadImage.js